export const ACCOUNTS = 'accounts';
export const USERS = 'users';
export const FRAMEWORKS = 'frameworks';
export const ASSESSMENTS = 'assessments';
export const PLANS = 'plans';
export const TEAMS = 'teams';